import { PARTNER_TYPES } from '../../partner-types';
import { Roles } from '../../roles';
import { MenuItem } from '../types';

// Integration Settings (API Partner self-service)
// Hosts all partner-owned configurations that govern how the partner's
// integration with ryd behaves: authentication, branding, request validation,
// and fraud-protection rules.
export const integrationSettingsSection: MenuItem[] = [
  {
    headTitle1: 'Integration Settings',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
    requiresFleetApis: true,
    requiredRoles: [Roles.api_credentials_admin],
  },
  {
    path: '/integration-and-settings/overview',
    title: 'Overview',
    icon: 'stroke-home',
    iconf: 'fill-home',
    type: 'link',
    active: 'false',
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
    requiresFleetApis: true,
  },
  {
    // Match the route guard: this page is reachable without Fleet APIs, without
    // api_credentials_admin, and without an onboardingProfile projection.
    path: '/integration-and-settings/onboarding',
    title: 'Onboarding & Getting Started',
    icon: 'stroke-learning',
    iconf: 'fill-learning',
    type: 'link',
    active: 'false',
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER, PARTNER_TYPES.RYD_INTERNAL],
  },
  {
    path: '/integration-and-settings/api-credentials',
    title: 'API Credentials',
    icon: 'stroke-api-integration-widget',
    iconf: 'fill-api-integration-widget',
    type: 'link',
    active: 'false',
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
    requiredRoles: [Roles.api_credentials_admin],
    requiresFleetApis: true,
  },
  {
    path: '/integration-and-settings/ui-settings',
    title: 'UI Customization',
    icon: 'stroke-palette',
    iconf: 'fill-palette',
    type: 'link',
    active: 'false',
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
    requiredRoles: [Roles.api_credentials_admin],
    requiresFleetApis: true,
  },
  {
    path: '/integration-and-settings/data-validation',
    title: 'Data Validation',
    icon: 'stroke-form',
    iconf: 'fill-form',
    type: 'link',
    active: 'false',
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
    requiredRoles: [Roles.api_credentials_admin],
    requiresFleetApis: true,
  },
  {
    path: '/integration-and-settings/fraud-rules',
    title: 'Fraud Rules',
    icon: 'stroke-secure-file',
    iconf: 'fill-secure-file',
    type: 'link',
    active: 'false',
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
    requiredRoles: [Roles.api_credentials_admin],
    requiresFleetApis: true,
  },
];
